export default function(x) {
  var y = 1 + x;
  var z = y - 1;

  return z === 0 ? x : x * Math.log(y) / z;
}



//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/log1py.js
// module id = xIMV
// module chunks = 0